import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function integerValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        if (value === null || value === undefined || value === '') {
            return null;
        }

        if (typeof value !== 'number' && typeof value !== 'string') {
            return { notInteger: true };
        }

        if (typeof value === 'string' && !/^-?\d+(\.\d+)?$/.test(value.trim())) {
            return { notInteger: true };
        }

        const num = Number(value);

        return Number.isFinite(num) && Number.isInteger(num) ? null : { notInteger: true };
    };
}
